import React from "react";

/**
 * A component for previewing how award tiers will appear to participants
 */
export function AwardPreview({ award, isPercentageBased }) {
  return (
    <div
      className="flex items-center gap-4 p-4 rounded-lg"
      style={{ backgroundColor: award.color + '20' }}
    >
      <div
        className="w-3 h-3 rounded-full"
        style={{ backgroundColor: award.color }}
      />
      <div className="flex-1">
        <div className="font-medium">{award.name || "Unnamed Award"}</div>
        <div className="text-sm opacity-70">
          {award.maxScore.toFixed(isPercentageBased ? 1 : 0)}
          {isPercentageBased ? "%" : " pts"} - {award.minScore.toFixed(isPercentageBased ? 1 : 0)}
          {isPercentageBased ? "%" : " pts"}
        </div>
      </div>
    </div>
  );
} 